// message
export function responseMessage ({ dispatch }, payload) {
  dispatch('message/responseMessage', payload)
}

export function clearMessage ({ dispatch }) {
  dispatch('message/clearMessage')
}

export async function fetchOutlets ({ dispatch }) {
  await dispatch('config/fetchOutlets')
}

export function changeStore ({ dispatch }, payload) {
  dispatch('changeGroup', payload.gid)
  dispatch('changeOutlet', payload.rid)
}

export function changeGroup ({ dispatch }, payload) {
  dispatch('config/changeGid', payload)
  dispatch('auth/resetUser')
  dispatch('member/resetMemberData')
  dispatch('voucher/resetVoucherData')
  dispatch('order/resetOrderData')
  dispatch('config/resetTables')
  dispatch('changeTable', '')
}

export function changeOutlet ({ dispatch }, payload) {
  dispatch('config/changeRid', payload)
  dispatch('config/resetResDetails')
  dispatch('menu/resetMenuData')
  dispatch('cart/resetCartData')
  dispatch('order/resetOrderData')
  dispatch('config/resetTables')
  dispatch('voucher/resetVoucherData')
  dispatch('changeTable', '')
  dispatch('dialog/hideSettingDialog')
}

export function changeTable ({ dispatch }, payload) {
  dispatch('config/changeTb', payload)
}

export function changeDiningMode ({ dispatch, rootState }, payload) {
  if (rootState.config.mode.index !== parseInt(payload.index)) {
    dispatch('order/resetActiveOrderData')
    dispatch('config/changeMode', payload)
    dispatch('changeTable', '')
    dispatch('menu/resetMenuData')
    dispatch('cart/resetCartData')
  }
}

export async function fetchOutletConfig ({ dispatch }) {
  dispatch('dialog/hideSettingDialog')
  await dispatch('config/fetchConfig')
  await dispatch('banner/fetchBanners')
  await dispatch('config/fetchTables')
}

export async function fetchConfig ({ dispatch }) {
  await dispatch('config/fetchConfig')
}

export async function fetchOutletCats ({ dispatch }) {
  await dispatch('config/fetchCatGroups')
  await dispatch('config/fetchCats')
}

export function fetchMode ({ dispatch, rootState, rootGetters }) {
  let currentMode = rootState.config.mode ? rootGetters['config/modes'].find(m => m.isTakeaway == rootState.config.mode.isTakeaway && m.isDinein == rootState.config.mode.isDinein && m.isDelivery == rootState.config.mode.isDelivery) : null
  const mode = currentMode || rootGetters['config/modes'][0]
  dispatch('config/changeMode', mode)
  if (mode.isDinein) {
    dispatch('dialog/hideSettingDialog')
  }
  if (mode.isDelivery) {
    dispatch('dialog/showSettingDialog', 'address')
  }
  if (mode.isTakeaway && !rootGetters['cart/pickupDate'] && !rootGetters['cart/pickupTime']) {
    dispatch('dialog/showSettingDialog', 'timer')
  }
}

export function setModeByString ({ dispatch, rootState, rootGetters }, payload) {
  let isDelivery = false
  let isDinein = false
  let isTakeaway = false
  if (payload === 'dine_in') {
    isDinein = true
  } else if (payload === 'takeaway') {
    isTakeaway = true
  } else if (payload === 'delivery') {
    isDelivery = true
  }
  const modes = rootGetters['config/modes']
  for (let i = 0; i < modes.length; i++) {
    const mode = modes[i]

    if (
      mode.isDelivery == isDelivery &&
      mode.isDinein == isDinein &&
      mode.isTakeaway == isTakeaway
    ) {
      dispatch('config/setModeSelected')
      dispatch('order/resetActiveOrderData')
      dispatch('config/changeMode', mode)
      dispatch('changeTable', '')
      dispatch('menu/resetMenuData')
      dispatch('cart/resetCartData')

      if (mode.isDinein) {
        dispatch('dialog/hideSettingDialog')
      }
      if (mode.isDelivery) {
        dispatch('dialog/showSettingDialog', 'address')
      }
      if (mode.isTakeaway && !rootGetters['cart/pickupDate'] && !rootGetters['cart/pickupTime']) {
        dispatch('dialog/showSettingDialog', 'timer')
      }
    }
  }
}

export async function fetchMenuCats ({ dispatch }) {
  dispatch('menu/fetchSubmenu')
  await dispatch('menu/fetchMenuCats')
}

export async function fetchCatItems ({ dispatch }, payload) {
  await dispatch('menu/fetchCatItems', payload)
}

export async function fetchMemberAll ({ dispatch }) {
  await dispatch('order/fetchAllOrders')
  await dispatch('auth/fetchAddresses')
}

export async function resetAllData ({ dispatch }) {
  dispatch('menu/resetMenuData')
  dispatch('cart/resetCartData')
  dispatch('order/resetOrderData')
  dispatch('receipt/resetReceiptData')
  dispatch('member/resetMemberData')
  dispatch('voucher/resetVoucherData')
  await dispatch('config/fetchConfig')
  await dispatch('banner/fetchBanners')
  await dispatch('voucher/fetchAllVouchers')
}

export async function resetAppRelatedData ({ dispatch }) {
  dispatch('menu/resetMenuData')
  dispatch('cart/resetCartData')
  dispatch('order/resetOrderData')
  dispatch('voucher/resetVoucherData')
  dispatch('dialog/hideSettingDialog')
  await dispatch('config/fetchConfig')
  await dispatch('banner/fetchBanners')
}

export async function fetchLatestVersion ({ dispatch }) {
  await dispatch('config/fetchLatestVersion')
}

export async function fetchTables ({ dispatch }) {
  await dispatch('config/fetchTables')
}

export function changePage ({ dispatch, rootGetters }) {
  if (rootGetters['dialog/settingDialog'] && rootGetters['dialog/type'] === 'table') {
    dispatch('dialog/hideSettingDialog')
  }
  if (rootGetters['menu/menuItem']) {
    dispatch('menu/hideMenuItemDialog')
    dispatch('cart/hideCartItemDialog')
  }
  dispatch('menu/hideCatListDialog')
}

export function resetModeSelected ({ dispatch }) {
  dispatch('area/resetSelectedAreaMode')
  dispatch('config/resetModeSelected')
}

export async function fetchAreas ({ dispatch }) {
  await dispatch('area/fetchAreas')
}

export async function setSelectedArea ({ dispatch }, payload) {
  await dispatch('area/setSelectedArea', payload)
}

export function resetSelectedArea ({ dispatch }) {
  dispatch('area/clearRestaurantDistance')
  dispatch('area/resetSelectedAreaMode')
  dispatch('area/resetSelectedArea')
  dispatch('area/resetPostalCode')
  dispatch('area/resetNearestOutlet')
  dispatch('area/resetAreaMsg')
  dispatch('area/resetDeliverable')
}

export function setSelectedAreaMode ({ dispatch }) {
  dispatch('area/setSelectedAreaMode')
}

export function resetSelectedAreaMode ({ dispatch }) {
  dispatch('area/resetSelectedAreaMode')
}

export function removeAllDiscountVoucher ({ dispatch }) {
  dispatch('cart/resetDiscountInfo')
  dispatch('cart/removeDiscountCartVoucher')
}

export async function fetchMembershipInfo ({ dispatch }) {
  await dispatch('member/fetchMembership')
  await dispatch('member/fetchMembershipConfig')
  await dispatch('config/fetchCats')
}

export function changeTime ({ dispatch }) {
  dispatch('order/resetActiveOrderData')
  dispatch('changeTable', '')
  dispatch('menu/resetMenuData')
  dispatch('cart/resetCartData')
  dispatch('menu/fetchMenuCats')
}

export async function reinitialise ({ dispatch }) {
  dispatch('menu/resetMenuData')
  dispatch('cart/resetCartData')
  await dispatch('config/fetchConfig')
  await dispatch('banner/fetchBanners')
  await dispatch('voucher/fetchAllVouchers')
}

export async function memberTokenLogin ({ dispatch }) {
  await dispatch('auth/memberTokenLogin')
}

export function logAxios ({ dispatch }, payload) {
  dispatch('message/logAxios', payload)
}

export function fetchDineInTimes ({ dispatch }) {
  dispatch('dine_mode/fetchDineInTimes')
}



// WEBPACK FOOTER //
// ./src/store/actions.js